/**
 * LandingPage — page d'accueil publique de mon-ministere.com.
 * Assemble Navbar + 8 sections + Footer.
 */
import { useEffect } from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Probleme from "../components/landing/Probleme";
import Fonctionnalites from "../components/landing/Fonctionnalites";
import PourQui from "../components/landing/PourQui";
import Temoignages from "../components/landing/Temoignages";
import Tarifs from "../components/landing/Tarifs";
import Presence from "../components/landing/Presence";
import CtaFinal from "../components/landing/CtaFinal";
import Footer from "../components/landing/Footer";
import DeviseBanner from "../components/landing/DeviseBanner";
import WhatsAppFAB from "../components/WhatsAppFAB";
import { colors } from "../styles/tokens";

export default function LandingPage() {
  // Scroll smooth global pour les ancres internes
  useEffect(() => {
    const previous = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "smooth";
    return () => { document.documentElement.style.scrollBehavior = previous; };
  }, []);

  return (
    <div style={{
      background: colors.bg,
      color: colors.text,
      minHeight: "100vh",
      overflowX: "hidden",
      maxWidth: "100vw",
    }}>
      <DeviseBanner />
      <Navbar />
      <main>
        <Hero />
        <Probleme />
        <Fonctionnalites />
        <PourQui />
        <Temoignages />
        <Tarifs />
        <Presence />
        <CtaFinal />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
